import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { motion } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';
import bestHumanPortalLogoDark from '@/assets/branding/besthuman-client-portal-logo-dark.png';
import bestHumanPortalLogoLight from '@/assets/branding/besthuman-client-portal-logo-light.png';
import { APPEAR_SINGLE } from '@/shared/animations';
import { Button } from '@/shared/ui/Button';
import styles from './Home.module.css';

export function Home() {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const [searchParams] = useSearchParams();

  // WHY: Approval emails link here with `?signup=true` so new users land on
  // Auth0's signup screen instead of the default login tab.
  useEffect(() => {
    if (searchParams.get('signup') === 'true' && !isAuthenticated && !isLoading) {
      loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } });
    }
  }, [searchParams, isAuthenticated, isLoading, loginWithRedirect]);

  return (
    <main className={styles.page}>
      <div className={styles.shell}>
        <motion.section className={styles.panelCard} aria-labelledby="home-title" {...APPEAR_SINGLE}>
          <div className={styles.logoStack}>
            <img src={bestHumanPortalLogoLight} alt="BestHuman Client Portal" className={styles.logoLight} />
            <img src={bestHumanPortalLogoDark} alt="BestHuman Client Portal" className={styles.logoDark} />
          </div>
          <h1 id="home-title" className={styles.title}>
            Welcome back
          </h1>
          <p className={styles.panelText}>Sign in after your BestHuman Portal access has been set up.</p>

          <div className={styles.actions}>
            <Button onClick={() => loginWithRedirect()} disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Sign In'}
            </Button>
          </div>

          <div className={styles.guidance} aria-labelledby="home-first-time-title">
            <h2 id="home-first-time-title" className={styles.guidanceTitle}>
              First time here?
            </h2>
            <p className={styles.guidanceText}>
              Use the invitation link from your email to complete onboarding. We'll send setup instructions when your
              portal access is ready.
            </p>
          </div>
        </motion.section>
      </div>
    </main>
  );
}
